var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path } from "react-native-svg";
var SvgHudHistory = function SvgHudHistory(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    overflow: "visible",
    preserveAspectRatio: "none",
    style: {
      display: "block"
    },
    viewBox: "0 0 20 20"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    stroke: "#F2F6FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.75
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M2.917 10A7.083 7.083 0 1 0 10 2.917a7.67 7.67 0 0 0-5.3 2.158l-1.783 1.8"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M2.917 3.333v3.542h3.541M10 6.458V10l2.5 1.458"
  }))));
};
export default SvgHudHistory;